import type { FirebaseApp } from 'firebase/app'
import { getApps, initializeApp } from 'firebase/app'
import type { Auth, User } from 'firebase/auth'
import {
  createUserWithEmailAndPassword,
  getAuth,
  onAuthStateChanged,
  signOut,
} from 'firebase/auth'

let firebaseApp: FirebaseApp | null = null
let firebaseAuth: Auth | null = null

/**
 * Just FYI
 * For third-party login methods, set authDomain to window.location.hostname when initializing Firebase.
 * */

export function initFirebase(config) {
  if (firebaseApp) return firebaseApp

  const apps = getApps()
  if (apps.length > 0) {
    // eslint-disable-next-line prefer-destructuring
    firebaseApp = apps[0]
  } else {
    firebaseApp = initializeApp(config)
  }

  return firebaseApp
}

function getFirebaseAuth() {
  if (firebaseAuth) return firebaseAuth

  const apps = getApps()
  if (apps.length === 0) return null

  firebaseAuth = getAuth(apps[0])
  return firebaseAuth
}

export async function firebaseSignOut() {
  const auth = getFirebaseAuth()
  if (!auth) return
  await signOut(auth)
}

export function firebaseCreateAccount(email: string, password: string) {
  const auth = getFirebaseAuth()
  if (!auth) throw new Error('Firebase Auth not initialized')

  return createUserWithEmailAndPassword(auth, email, password)
}

export function firebaseOnAuthStateChanged(
  callback: (user: User | null) => void,
) {
  const auth = getFirebaseAuth()
  if (!auth) return null
  return onAuthStateChanged(auth, callback)
}
